<template>
  <div class="vtoFooter">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VtoFooter',
};
</script>
